<template>
  <div>
    <Modal v-model="show" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">二维码配置</h3>
      <div>
        <img class="imgwidth" v-if="qrCodeUrl" :src="qrCodeUrl"/>
        <Upload class="upload"
          :action="baseUrl+'/file/uploadFile'"
          :on-success="handleSuccess"
          :headers="{'Access-Token':token}"
          :show-upload-list="false"
          :on-error="handleError"
          :format="['jpg','jpeg','png']"
          :on-format-error="handleFormatError"
        >
          <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
        </Upload>
      </div>
    </Modal>
  </div>

</template>

<script>
  import {houseTypeConfig} from "api/houseTypeConfig";
  import {getBaseUrl} from "@/utils/public";
  import {getToken} from "@/utils/auth";

  export default {
    name: "HeadImg",
    props:{
      img:{
        type:String,
        default:''

      },
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        // this.headImga=''
        // this.getProjectConfigInfo()
        this.show=true
      },
      img(val) {
        this.qrCodeUrl = val
      }

    },
    data(){
      return {
        show:false,
        token: '',
        baseUrl: '',
        qrCodeUrl:'',
        loading:true
      }
    },
    methods:{
      ok(){
        this.houseTypeConfig()

      },
      handleError(){

      },
      handleFormatError() {
      this.$Message.error('请输入jpg,jpeg,png,格式的文件')
    },
      handleSuccess(response){
        this.qrCodeUrl = response.data.url
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      houseTypeConfig(){
        if(!this.fid || !this.qrCodeUrl){
          this.changeLoading()
          this.$emit('refresh')
          this.show = false
          return
        }
        let data = {
          fid: this.fid,
          qrcode_url: this.qrCodeUrl
        }
        houseTypeConfig(data).then(res=>{
          this.$Message.success('二维码图片配置成功')
          this.changeLoading()
          this.$emit('refresh')
          this.show = false
       
        })
      }
    },
    created(){
      // this.getProjectConfigInfo()
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .imgwidth{
    width: 100px;
    height: 100px;
    vertical-align: middle;
  }
  .upload {
    display: inline-block;
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 100px;
    vertical-align: middle;
  }

</style>
